module.exports = __webpack_public_path__ + "static/media/README.4ac38ce0.md";